import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "w-full max-w-lg rounded-3xl bg-white p-6 shadow-2xl" }
const _hoisted_2 = { class: "mb-4 flex items-start justify-between gap-4" }
const _hoisted_3 = { class: "text-2xl font-display font-semibold text-slate-900" }
const _hoisted_4 = { class: "space-y-5" }
const _hoisted_5 = { class: "table-fixed w-full text-sm text-slate-700" }
const _hoisted_6 = { class: "w-2/5 py-1 font-semibold" }
const _hoisted_7 = { class: "py-1 font-semibold" }
const _hoisted_8 = {
  key: 0,
  class: "text-emerald-700"
}
const _hoisted_9 = { class: "py-1 font-semibold align-top" }
const _hoisted_10 = { class: "mb-1 block font-semibold text-slate-800" }
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = {
  key: 0,
  class: "rounded-2xl border border-rose-200 bg-rose-50 px-4 py-3 text-rose-600"
}
const _hoisted_13 = { class: "flex justify-end gap-3" }
const _hoisted_14 = ["disabled"]

import { computed, onBeforeUnmount, onMounted, ref } from "vue";
import Nprogress from "nprogress";
import { instrumentI } from "@/interfaces/interfaces";


export default /*@__PURE__*/_defineComponent({
  __name: 'ServiceVerzoekModal',
  props: {
    instrument: {},
    language: {},
    requestUrl: {}
  },
  emits: ["close", "submitted"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const omschrijving = ref("");
const error = ref("");
const submitting = ref(false);

const translations: { [key: string]: { [key: string]: string } } = {
  nl: {
    titel: "Serviceverzoek indienen",
    instrumentnaam: "Instrument",
    serienummer: "Serienummer",
    omschrijving: "Toelichting",
    omschrijvingPlaceholder: "Beschrijf uw serviceverzoek...",
    verzenden: "Verzenden",
    annuleren: "Annuleren",
    fout: "Er is een fout opgetreden bij het indienen van uw verzoek.",
    serviceverzoekIngediend: "Serviceverzoek in behandeling sinds",
  },
  fr: {
    titel: "Soumettre une demande de service",
    instrumentnaam: "Instrument",
    serienummer: "Numéro de série",
    omschrijving: "Description",
    omschrijvingPlaceholder: "Décrivez votre demande de service...",
    verzenden: "Envoyer",
    annuleren: "Annuler",
    fout: "Une erreur s'est produite lors de la soumission de votre demande.",
    serviceverzoekIngediend: "Demande de service en cours de traitement depuis le",
  },
  en: {
    titel: "Submit service request",
    instrumentnaam: "Instrument",
    serienummer: "Serial number",
    omschrijving: "Description",
    omschrijvingPlaceholder: "Describe your service request...",
    verzenden: "Submit",
    annuleren: "Cancel",
    fout: "An error occurred while submitting your request.",
    serviceverzoekIngediend: "Service request being processed since",
  },
  de: {
    titel: "Serviceanfrage einreichen",
    instrumentnaam: "Instrument",
    serienummer: "Seriennummer",
    omschrijving: "Beschreibung",
    omschrijvingPlaceholder: "Beschreiben Sie Ihre Serviceanfrage...",
    verzenden: "Absenden",
    annuleren: "Abbrechen",
    fout: "Beim Einreichen Ihrer Anfrage ist ein Fehler aufgetreten.",
    serviceverzoekIngediend: "Serviceanfrage in Bearbeitung seit",
  },
};

const translation = computed(() => {
  return translations[props.language] || translations.nl;
});

const t = (key: string) => {
  return translation.value[key];
};

const serviceVerzoekDatum = computed(() => {
  const value = props.instrument.serviceVerzoekInstuurdatum;
  if (!value) return "";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "" : date.toLocaleDateString();
});

const canSubmit = computed(() => !submitting.value && omschrijving.value.trim().length > 0);

const handleEscape = (e: KeyboardEvent) => {
  if (e.key === "Escape") emit("close");
};

onMounted(() => window.addEventListener("keydown", handleEscape));
onBeforeUnmount(() => window.removeEventListener("keydown", handleEscape));

const submit = async () => {
  submitting.value = true;
  error.value = "";
  Nprogress.start();

  try {
    const response = await fetch(props.requestUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        type: "serviceverzoek",
        Serienummer: props.instrument.Serienummer,
        Itemcode: props.instrument.Itemcode,
        omschrijving: omschrijving.value,
      }),
    });

    if (!response.ok) {
      const data = await response.json().catch(() => undefined);
      throw new Error((data && data.message) || response.statusText);
    }

    emit("submitted");
    emit("close");
  } catch (err) {
    error.value = err instanceof Error && err.message ? err.message : t("fout");
  } finally {
    submitting.value = false;
    Nprogress.done();
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "fixed inset-0 z-50 flex items-center justify-center bg-slate-950/60 px-4 py-6",
    onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", _hoisted_3, _toDisplayString(t("titel")), 1),
        _createElementVNode("button", {
          class: "rounded-full border border-slate-200 px-3 py-1 text-sm text-slate-600 transition hover:border-slate-300 hover:text-slate-900",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, _toDisplayString(t("annuleren")), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("table", _hoisted_5, [
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_6, _toDisplayString(t("instrumentnaam")), 1),
              _createElementVNode("td", null, _toDisplayString(__props.instrument.Instrumentnaam), 1)
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_7, _toDisplayString(t("serienummer")), 1),
              _createElementVNode("td", null, _toDisplayString(__props.instrument.Serienummer), 1)
            ]),
            (serviceVerzoekDatum.value)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
                  _createElementVNode("td", _hoisted_9, _toDisplayString(t("serviceverzoekIngediend")), 1),
                  _createElementVNode("td", null, _toDisplayString(serviceVerzoekDatum.value), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("label", _hoisted_10, _toDisplayString(t("omschrijving")), 1),
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((omschrijving).value = $event)),
            placeholder: t('omschrijvingPlaceholder'),
            rows: "5",
            class: "w-full rounded-2xl border border-slate-200 px-4 py-3 text-slate-700 outline-none transition focus:border-gullimex-orange"
          }, null, 8, _hoisted_11), [
            [_vModelText, omschrijving.value]
          ])
        ]),
        (error.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(error.value), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("button", {
            class: "rounded-xl border border-slate-200 px-4 py-2 font-semibold text-slate-700 transition hover:border-slate-300 hover:bg-slate-50",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
          }, _toDisplayString(t("annuleren")), 1),
          _createElementVNode("button", {
            disabled: !canSubmit.value,
            class: "rounded-xl bg-gullimex-orange px-4 py-2 font-semibold text-white transition hover:bg-amber-500 disabled:cursor-not-allowed disabled:opacity-50",
            onClick: submit
          }, _toDisplayString(t("verzenden")), 9, _hoisted_14)
        ])
      ])
    ])
  ]))
}
}

})